import(/* webpackMode: "eager" */ "/vercel/path0/src/app/meals/page.tsx");
